// extracted by mini-css-extract-plugin
module.exports = {"select":"ContactForm_select___5Vk2","rich":"ContactForm_rich__9_X9w"};